import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "../../lib/api";
import { ANNOUNCEMENTS } from "../../data/site";

export const AnnouncementBar = () => {
  const [items, setItems] = useState(ANNOUNCEMENTS);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/announcements")
      .then((r) => {
        if (cancelled) return;
        const list = r.data?.items || [];
        if (list.length) setItems(list);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const text = items.join("  •  ");
  return (
    <div
      data-testid="announcement-bar"
      className="flex items-center gap-3 px-3 py-2 overflow-hidden"
      style={{ background: "linear-gradient(90deg, #0e1620 0%, #0a1119 50%, #0e1620 100%)" }}
    >
      <div className="shrink-0 flex items-center gap-2 px-2 py-1 rounded text-xs font-semibold bg-[#19a55c]/20 text-[#7ddca7] border border-[#19a55c]/30">
        <Megaphone size={12} />
        News
      </div>
      <div className="flex-1 overflow-hidden whitespace-nowrap">
        <div
          className="inline-block whitespace-nowrap text-sm text-white/80"
          style={{ animation: "marquee 110s linear infinite" }}
        >
          {text}&nbsp;&nbsp;&nbsp;{text}
        </div>
      </div>
    </div>
  );
};
